import { render, staticRenderFns } from "./OActiveButton.vue?vue&type=template&id=36f7ea5e&scoped=true&"
import script from "./OActiveButton.vue?vue&type=script&lang=js&"
export * from "./OActiveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f7ea5e",
  null
  
)

export default component.exports